
























































































import { mixins, Component, Watch } from 'nuxt-property-decorator';
import FocusLock from 'vue-focus-lock';
import clickOutside from '@/directives/click_outside';
import UniversalSearchMixin from '@/components/common/UniversalSearch/UniversalSearchMixin';
import UniversalSearchResults from '@/components/common/UniversalSearch/UniversalSearchResults/UniversalSearchResults.vue';
import UniversalSearchSuggestions from '@/components/common/UniversalSearch/UniversalSearchSuggestions.vue';
import UniversalSearchHint from '@/components/common/UniversalSearch/UniversalSearchHint.vue';
import DualRingLoader from '@/components/common/DualRingLoader.vue';
import SearchIcon from '@/components/common/UniversalSearch/images/search.vue.svg';
import ArrowIcon from '@/components/common/UniversalSearch/images/arrow-right.vue.svg';
import ScrollLock from '@/components/utils/browser/scrollLock';
import ProgressBar from '@/components/utils/browser/nuxtLoadingProgressBar';
import { handleFocusInElement, isFocusInsideElement } from '@/components/utils/browser/keyboardNavigation';

@Component<UniversalSearch>({
  directives: {
    'click-outside': clickOutside,
  },
  components: {
    FocusLock,
    DualRingLoader,
    SearchIcon,
    ArrowIcon,
    UniversalSearchResults,
    UniversalSearchSuggestions,
    UniversalSearchHint,
  },
})
export default class UniversalSearch extends mixins(UniversalSearchMixin) {
  isExpandable: boolean = false;
  isFocused: boolean = false;
  searchQuery: string = '';

  get isValidSearchQuery() {
    return this.searchQuery.trim().length >= this.minSearchChars;
  }

  get placeholder() {
    if (this.isFocused) return '';
    return 'I can answer your toughest sales questions';
  }

  handleFocus() {
    this.isFocused = true;
    this.handleExpand();
  }

  handleBlur() {
    this.isFocused = false;
  }

  handleBrowse() {
    this.$analytics.logEvent('search__more__click', {
      query: this.query,
      queryId: this.queryId,
      version: 'v1',
    });
    this.handleShowMore();
  }

  handleSuggestionSelect(suggestion: string) {
    this.searchQuery = suggestion;
    this.handleShowMore();
  }

  handleExpand() {
    this.isExpandable = true;

    // Focus on input on mobile when open
    if (this.$breakpoint.xs) {
      this.$nextTick(() => {
        (this.$refs.input as HTMLInputElement)?.focus();
      });
    }

    ScrollLock.enable();
    ProgressBar.hide();
  }

  handleCollapse() {
    if (!this.isExpandable) return;
    this.isExpandable = false;
    ScrollLock.disable();
    ProgressBar.show();
  }

  handleClear() {
    this.searchQuery = '';
    (this.$refs.input as HTMLInputElement)?.focus();
  }

  handleEscape() {
    // If focus is inside results, focus on search input
    if (isFocusInsideElement(this.$refs.results as HTMLElement)) {
      (this.$refs.input as HTMLInputElement)?.focus();
      return;
    }

    this.handleCollapse();
    this.searchQuery = '';
    (this.$refs.input as HTMLInputElement)?.blur();
  }

  handleKeyboardNavigation(type: 'up' | 'down') {
    if (this.isSearching) return;
    handleFocusInElement(this.$refs.universalSearch as HTMLElement, type === 'up' ? -1 : 1);
  }

  handleShowMore() {
    const query = this.searchQuery.trim();
    this.$router.push(`/search?query=${encodeURIComponent(query)}`, this.handleCollapse);
  }

  beforeDestroy() {
    this.handleCollapse();
  }

  @Watch('$route.query.query', { immediate: true })
  handleSearchQueryChange(newValue: string) {
    this.searchQuery = newValue ?? '';
  }

  @Watch('$route.path')
  handlePageChange(newValue: string) {
    // Clear search when navigating, but not on search result page
    if (newValue !== '/search') {
      this.searchQuery = '';
    }
  }
}
